'use strict';

var GroupNameService = function GroupNameService() {
  var groupMetadata = {
    label: 'New group',
    counter: 0
  };
  function getName() {
    var label = groupMetadata.counter >= 1 ? groupMetadata.label + ' ' + groupMetadata.counter : groupMetadata.label;
    groupMetadata.counter++;
    return label;
  }
  return {
    getName: getName
  };
};
module.exports = GroupNameService;